/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcJpmamV1DestinationEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_JPMAM_V1_DESTINATION_EVENT_ENTITY_NAME = 'exc.jpmam.v1.DestinationEvent';
export const excJpmamV1DestinationEventEntity = new schema.Entity<ExcJpmamV1DestinationEvent>(EXC_JPMAM_V1_DESTINATION_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: ExcJpmamV1DestinationEvent) => `${entity.metadata?.eventId}` });

